import { lazy } from "react";
import PathConstants from "./pathConstants";
import BbbTest from "../pages/bbbTest/BbbTest";
// import Profile from "../pages/profile/Profile";
// import Cv from "../pages/cv/Cv";
// import CourseRegister from "../pages/courseRegister/CourseRegister";
// import Homeworks from "../pages/homeworks/Homeworks";
// import SolutionPage from "../pages/homeworks/Solution/SolutionPage";
// import RegisteredCourse from "../pages/registeredCourse/RegisteredCourse";
// import RecordedLessonPage from "../pages/recordedLesson/RecordedLessonPage";
// import RegisteredLiveCourse from "../pages/registeredLiveCourse/RegisteredLiveCourse";
// import Payment from "../pages/payment/Payment";
// import Agora from "../pages/agora/Agora";
const Profile = lazy(() => import("../pages/profile/Profile"));
const Cv = lazy(() => import("../pages/cv/Cv"));
const CourseRegister = lazy(() =>
  import("../pages/courseRegister/CourseRegister")
);
const Homeworks = lazy(() => import("../pages/homeworks/Homeworks"));
const SolutionPage = lazy(() =>
  import("../pages/homeworks/Solution/SolutionPage")
);
const RegisteredCourse = lazy(() =>
  import("../pages/registeredCourse/RegisteredCourse")
);
const RecordedLessonPage = lazy(() =>
  import("../pages/recordedLesson/RecordedLessonPage")
);
const RegisteredLiveCourse = lazy(() =>
  import("../pages/registeredLiveCourse/RegisteredLiveCourse")
);
const RecordedLiveLessonPage = lazy(() =>
  import("../pages/recordedLiveLesson/RecordedLiveLessonPage")
);

const Agora = lazy(() => import("../pages/agora/Agora"));
const Payment = lazy(() => import("../pages/payment/Payment"));

const PrivateRoutes = [
  {
    path: PathConstants.Profile,
    children: [
      {
        path: PathConstants.ProfileDetails,
        element: <Profile />,
      },
      {
        path: PathConstants.ProfileCourses,
        element: <Profile />,
      },
      {
        path: PathConstants.ProfileSettings,
        element: <Profile />,
      },
      {
        path: PathConstants.ProfileWithSpecificCourse,
        element: <Profile />,
      },
    ],
  },

  // {
  //   path: PathConstants.Cv,
  //   element: <Cv />,
  // },
  {
    path: PathConstants.RegisterCourse,
    element: <CourseRegister />,
  },
  {
    path: PathConstants.RegisterRecordedCourse,
    element: <CourseRegister />,
  },
  {
    path: PathConstants.HomeWorks,
    element: <Homeworks />,
  },
  {
    path: PathConstants.Solution,
    element: <SolutionPage />,
  },
  {
    path: PathConstants.RecordedCouse,
    element: <RegisteredCourse />,
  },
  {
    path: PathConstants.LiveCourse,
    element: <RegisteredLiveCourse />,
  },
  {
    path: PathConstants.Activity,
    element: <Agora />,
  },
  {
    path: PathConstants.Payment,
    element: <Payment />,
  },
  {
    path: PathConstants.RecordedLiveLesson,
    element: <RecordedLiveLessonPage />,
  },
  { path: PathConstants.Lesson, element: <RecordedLessonPage /> },
  { path: PathConstants.LiveLesson, element: <Agora /> },
  { path: 'join-v2/:courseId/:id', element: <BbbTest /> },
  {
    path: 'join-v2/activity/:id',
    element: <BbbTest />,
  },
];
export default PrivateRoutes;
